import { Algolia, Hits } from '@/infrastructure/network/Algolia/schema'
import { AlgoliaRequest } from '@/infrastructure/network/AlgoliaRequest'

export class FetchHospital implements AlgoliaRequest<Algolia.Hospital.FetchHospitalResponse> {
  response: Algolia.Hospital.FetchHospitalResponse
  index: string
  items: string
  hits?: Hits
  word: string
  constructor(word?: string | null, hits?: Hits) {
    this.hits = hits
    this.word = word || ''
    this.index = `${process.env.SCOUT_PREFIX}hospitals`
    this.items = 'hospitals'
  }
}
